<nav class="instructor-bottom-nav">
  <a class="nav-tab" routerLink="/instructor/dashboard" routerLinkActive="active">
    <span class="material-icons">dashboard</span>
    <span class="tab-label">Dashboard</span>
  </a>
  <a class="nav-tab" routerLink="/instructor/timeline" routerLinkActive="active">
    <span class="material-icons">schedule</span>
    <span class="tab-label">Today</span>
  </a>
  <a class="nav-tab" routerLink="/instructor/instructor-lessons" routerLinkActive="active">
    <span class="material-icons">event_note</span>
    <span class="tab-label">Agenda</span>
  </a>
  <a class="nav-tab" [routerLink]="['/profile', userId]" routerLinkActive="active">
    <span class="material-icons">person</span>
    <span class="tab-label">Profile</span>
  </a>
  <!-- The header, with the profile menu and its Logout, is hidden for instructors on a phone (P12). -->
  <button type="button" class="nav-tab nav-tab--button" (click)="logout()" aria-label="Log out">
    <span class="material-icons">logout</span>
    <span class="tab-label">Log out</span>
  </button>
</nav>
